<template>
  <nav dir="ltr" id="mainTopNav" class="navbar bg-dark fixed-top text-light navbar-expand-lg py-1">
    <div class="container">
      <router-link :to="{ name: 'LandingPage' }" custom v-slot="{ navigate }" class="navbar-brand ms-2">
        <span
          role="link"
          @click="navigate"
          @keypress.enter="navigate"
        >
          <img src="../../public/storage/mobiletech-logo.png"
            alt="Mobile Tech Zone logo"
            height="30"
            class="d-inline-block align-text-top" />
        </span>
      </router-link>
      <button class="navbar-toggler text-light" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <i class="fa-solid fa-sm fa-bars"></i>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav small ms-auto mb-2 mb-lg-0">

            <li class="nav-item px-2">
            <router-link :to="{ name: 'About' }" custom v-slot="{ navigate }">
              <span
                role="link"
                @click="navigate"
                class="nav-link text-light"
                aria-current="page"
                @keypress.enter="navigate"
              >
                Über uns
              </span>
            </router-link>
          </li>

          <li class="nav-item px-2">
            <router-link :to="{ name: 'Repair' }" custom v-slot="{ navigate }">
              <span
                role="link"
                @click="navigate"
                class="nav-link text-light"
                aria-current="page"
                @keypress.enter="navigate"
              >
                Reparaturwerkstatt
              </span>
            </router-link>
          </li>
          <li class="nav-item px-2">
            <router-link :to="{ name: 'Contact' }" custom v-slot="{ navigate }">
              <span
                role="link"
                @click="navigate"
                class="nav-link text-light"
                aria-current="page"
                @keypress.enter="navigate"
              >
                Kontakt
              </span>
            </router-link>
          </li>
        </ul>
        <elDropdown class="" />
      </div>
    </div>
  </nav>
</template>

<script>
import elDropdown from "../modules/account/components/Dropdown.vue";

export default {
  name: "Navbar",

  components: {
    elDropdown,
  },

  data() {
    return {
      navigate: {},
      target: "",
      lastPositionScroll: 0,
    };
  },

  mounted() {
    this.$nextTick(() => {});
  },

  methods: {},
};
</script>

<style scoped></style>
